import React, {useEffect, useState} from 'react';

import { IMaskInput } from 'react-imask';

import { Dialog, DialogTitle, DialogContent, Switch, Grid, Box} from '@mui/material';
import { DialogActions } from '@mui/material';
import { TextField } from '@mui/material';
import { FormHelperText } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';


import '../../../../index.css';
import api from '../../../../api';
import Table from "../../../Table";

const EditGroupNameModal = (props) =>{
    const [clientGroupName, updateClientGroupName] = useState("")
    const [clientGroupDescription, updateClientGroupDescription] = useState("")
    const [clientGroupIds, updateClientGroupIds] = useState([])
    const [clientsObj, updateClientsObj] = useState({})
    const [clientsTableColumns, updateClientsTableColumns] = useState([])
    const [clientsFilter, updateClientsFilter] = useState({ items: [] })
    const [selectionModel, updateSelectionModel] = useState([])
    const [nextPage, updateNextPage] = useState(null)
    const [ready, updateReady] = useState(false)


    const fetchClientGroupIds = async () => {
        if(props.groupId === 0){
            return
        }

        const url = `/api/enterprises/${props.enterpriseId}/contact_group/${props.groupId}/`

        const response = await api.get(url)
        if (response.status === 404){
            return
       }
       updateClientGroupIds(response.data.contacts.map(each => each.contact));
       
    }


    const submit = async () => {
        const url = `/api/enterprises/${props.enterpriseId}/contact_group/${props.data.id}/`
        const body = {
            name : clientGroupName,
            description : clientGroupDescription,
            clients : clientGroupIds
        }
        const response = await api.patch(url,body)
        if (response.status === 404){
            // console.log('Response Fail') // chamar o notification padrão
            return
        }
        props.submit()
    }

    useEffect(() => {
        fetchClientGroupIds()
        updateReady(false)
    }, [props.groupId] )


    useEffect(() => {
        updateClientGroupName(props.data.name)
        updateClientGroupDescription(props.data.description)
        updateReady(true)
    }, [clientGroupIds])

    const mapClients = (clients) => {
        const clientsObj = {};

        clients.forEach((client) => {
            clientsObj[client.id] = client
        })

        return clientsObj;
    }



    const customRow = (props) => {
		const list_index = props.index;
		const list_size = props.clients.length;
		const value_opacity = list_size - list_index;

		return (
			<GridRow
				{...props}
				style={{
					opacity:
						(value_opacity < 10 && nextPage) ?
							`0.${value_opacity}` : null
				}}
			/>
		);
	}

    return (
        <div>
            {ready &&
            <Dialog keepMounted
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="customized-dialog-title"
                fullWidth
                disablePortal
                disableEnforceFocus
                sx={{position:'absolute'}}
            >
                <DialogTitle id="customized-dialog-title">
                    {props.title}
                </DialogTitle>
                <DialogContent>

                    <>
                    <TextField
                            size="small"
                            label="Nome"
                            fullWidth
                            type="text"
                            variant="outlined"
                            className="push-top"
                            value={clientGroupName}
                            InputLabelProps={{ shrink: true }}
                            onChange={(event) => {updateClientGroupName(event.target.value)}}
                        
                        />
                    <TextField
                            size="small"
                            label="Descrição"
                            fullWidth
                            type="text"
                            variant="outlined"
                            className="push-top"
                            value={clientGroupDescription}
                            InputLabelProps={{ shrink: true }}
                            onChange={(event) => {updateClientGroupDescription(event.target.value)}}
                        
                        />
                    </>
                </DialogContent>

                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                        <LoadingButton
                            onClick={() => submit()}
                            color="primary"
                            
                        >
                            {props.buttonText}
                        </LoadingButton>
                    </DialogActions>
            </Dialog>
        }
        </div>
    )
}

export default EditGroupNameModal
